<template>
	<GridLayout
		:reactive-sidebar="false"
		:sidebar-state="false"
		right-title="ORGANIZAÇÕES"
	>
		<template #right-content>
			<ToolBar>
				<div class="w-full flex justify-end">
					<router-link
						class="btn btn-primary px-5"
						:to="{
							name: 'NewOrganization',
							params: {
								pre_plan,
							},
						}"
					>
						ADICIONAR
					</router-link>
				</div>
			</ToolBar>

			<MainContent>
				<div class="w-full flex px-4 py-3">
					<div class="w-full">
						<div
							v-for="requester in visibleRequesters"
							:key="requester.id"
						>
							<template
								v-if="
									requester.confirmed ||
									requester.account_requester_id ===
										requester.account_provider_id
								"
							>
								<router-link
									class="select-card with-border mb-3"
									:to="{
										name: 'OrganizationPanel',
										params: {
											organization_id:
												requester.account_requester_id,
										},
									}"
								>
									<label>
										<small class="d-block opacity-50">
											{{
												requester.requester
													.document_number
											}}
										</small>
										{{
											requester.requester.name.toUpperCase()
										}}
										<i class="far fa-chevron-right"></i>
									</label>
								</router-link>
							</template>
							<template v-else>
								<div
									class="select-card select-blue with-border mb-3"
								>
									<label
										style="cursor: default"
										@click.prevent=""
									>
										<div class="w-full">
											<div class="w-full">
												A ORGANIZAÇÃO
												<b>{{
													requester.requester.name.toUpperCase()
												}}</b>
												ENVIOU UMA SOLICITAÇÃO DE
												CONEXÃO, DESEJA ACEITAR?
											</div>
											<div class="w-full mt-1">
												<div
													class="d-flex justify-content-between"
												>
													<button
														type="button"
														class="btn btn-danger btn-sm"
														@click="
															ConfirmWorkgroup(
																false,
																requester.id
															)
														"
													>
														RECUSAR
													</button>
													<button
														type="button"
														class="btn btn-success btn-sm"
														@click="
															ConfirmWorkgroup(
																true,
																requester.id
															)
														"
													>
														ACEITAR
													</button>
												</div>
											</div>
										</div>
									</label>
								</div>
							</template>
						</div>
					</div>
				</div>
			</MainContent>
		</template>
	</GridLayout>
</template>

<script>
	import Swal from 'sweetalert2'
	import { mapGetters, mapActions } from 'vuex'
	export default {
		name: 'OrganizationsList',

		data() {
			return {
				pre_plan: {},
			}
		},
		computed: {
			...mapGetters('auth', ['account', 'requesters']),
			getEngineOrganization() {
				return parseInt(process.env.VUE_APP_ENGINE_ORGANIZATION_ID)
			},
			visibleRequesters() {
				return this.requesters.filter(
					r => r.account_requester_id !== this.getEngineOrganization
				)
			},
		},
		watch: {
			pre_plan: {
				deep: true,
				handler(val) {
					if (val) {
						Swal.fire({
							title: `Adicione uma organização para aplicarmos a assinatura do plano "${val.name}"`,
							icon: 'info',
							toast: true,
							position: 'top-end',
							timer: 10000,
							timerProgressBar: true,
						})
					}
				},
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			...mapActions('auth', ['GetAuthAccount']),
			ConfirmWorkgroup(decision, id) {
				this.StartLoading()

				return window.api
					.call('post', '/confirm-workgroup', {
						workgroup_id: id,
						confirmed: decision,
					})
					.then(({ data }) => {
						if (data.response) {
							if (decision) {
								Swal.fire({
									text: 'Agora você pode acessar as informações da organização.',
									title: 'Conexão confirmada com sucesso',
									icon: 'success',
								})
							} else {
								Swal.fire({
									title: 'Conexão removida com sucesso',
									icon: 'success',
								})
							}

							this.GetAuthAccount()
						} else {
							Swal.fire({
								title: 'Opss...',
								text: 'Houve um erro ao concluir, contate o suporte.',
								icon: 'error',
							})
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			async HasPrePlan() {
				const vm = this

				vm.StartLoading()

				return await window.api
					.call('post', '/has-pre-plan', {
						account_id: this.account.id,
					})
					.then(async ({ data }) => {
						if (data.response) {
							await vm.GetPlan(data.pre_plan.plan_id)
						}

						if (vm.requesters.length === 0) {
							Swal.fire({
								title: `Crie uma organização para começar a utilizar o sistema! 👍`,
								icon: 'info',
								toast: true,
								position: 'top-end',
								timer: 10000,
								timerProgressBar: true,
							})
						}
					})
					.finally(() => {
						vm.FinishLoading()
					})
			},
			async GetPlan(plan_id) {
				const vm = this

				return await window.api
					.call('post', '/gateway/get-plan', {
						plan_id,
					})
					.then(({ data }) => {
						if (data.response) {
							vm.pre_plan = data.plan
							vm.pre_plan.benefits = JSON.parse(
								data.plan.description
							).benefits
							vm.pre_plan.description = JSON.parse(
								data.plan.description
							).description

							return
						}

						Swal.fire({
							text: 'Não foi possível carregar o plano selecionado no inicio do cadastro, contate o suporte.',
							icon: 'error',
							title: 'Eita!',
						})
					})
			},
		},
		beforeMount() {
			// this.GetAuthAccount()
			this.HasPrePlan()
		},
	}
</script>

<style lang="css" scoped>
	.swal-message {
		display: flex;
	}
</style>
